import { z } from "zod";

export const referralCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z0-9]{8}$/, "Código de indicação deve ter 8 caracteres");

export const meuCodigoResponseSchema = z.object({
  codigo: referralCodeSchema,
});

export const validateCodigoResponseSchema = z.object({
  valido: z.boolean(),
  nomeIndicador: z.string().optional(),
});

export const indicacaoStatusSchema = z.enum(["pendente", "concluida"]);

export const indicacaoResponseSchema = z.object({
  id: z.number(),
  nomeIndicado: z.string(),
  status: indicacaoStatusSchema,
  valorCredito: z.number(),
  createdAt: z.string(),
  completedAt: z.string().nullable(),
});

export const registrarIndicacaoSchema = z.object({
  codigo: referralCodeSchema,
});

export type ReferralCode = z.infer<typeof referralCodeSchema>;
export type MeuCodigoResponseDto = z.infer<typeof meuCodigoResponseSchema>;
export type ValidateCodigoResponseDto = z.infer<typeof validateCodigoResponseSchema>;
export type IndicacaoStatus = z.infer<typeof indicacaoStatusSchema>;
export type IndicacaoResponseDto = z.infer<typeof indicacaoResponseSchema>;
export type RegistrarIndicacaoDto = z.infer<typeof registrarIndicacaoSchema>;
